import './UnbelievableSummerDeals.css';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
import getListing from '../../utils/getListing';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import Switch from '../Listing/Switch';
import { convertQueryParamsToFacets } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNil } from '../../utils/IsNil';
import { checkJssError } from '../../utils/checkJssError';
import ScrollAnimation from 'react-animate-on-scroll';
import throttle from 'lodash/throttle';
import useProfile from '../../utils/hooks/useProfile';
const getFacetNamesValue = filterData => filterData ? filterData.values.map(filter => get(filter, 'fieldNameItem.item.fieldName.value')) : [];
const UnbelievableSummerDealsComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const location = useLocation();
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const userProfile = useProfile();
  const [hits, setHits] = useState([]);
  const [facets, setFacets] = useState([]);
  const [defaultFacets, setDefaultFacets] = useState();
  const title = get(fields, 'data.listingConfiguration.title.jss.value') || get(fields, 'data.listingConfiguration.name');
  const pageSize = get(fields, 'data.listingConfiguration.pageSize.jss.value');
  const description = get(fields, 'data.listingConfiguration.shortDescription.jss.value');
  const showMoreButtonText = get(fields, 'data.showMoreButton.title.jss.value');
  const showMoreButtonHref = get(fields, 'data.showMoreButton.link.jss.value.href');
  const currency = get(fields, 'data.listingConfiguration.currency.targetItem.currencyId.jss.value');
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters') || [];
  const filtersArray = get(fields, 'data.listingConfiguration.filters.values') || [];
  const socialSharing = get(fields, 'data.socialSharing');
  const algoliaIndexes = get(params, 'SearchIndex');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const dictionary = get(fields, 'data.dictionary');
  const bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  const fromText = getDictionaryItem(dictionary, 'from') || '';
  const offText = getDictionaryItem(dictionary, 'off') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  const carouselWrapperRef = useRef(null);
  const [titleHeight, setTitleHeight] = useState(0);
  const [websiteHeight, setWebsiteHeight] = useState(0);
  const selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'Select all';
  const queryParams = qsToObject(location.search);
  let facetFilters = convertQueryParamsToFacets(queryParams, true, filterData);
  const analytics = {
    filterAnalytics: eventsAnalytics['callToCategoryAnalytics'],
    params
  };
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current) {
        let titleHeight = 0,
          websiteHeight = 0;
        const titlesList = carouselWrapperRef.current.querySelectorAll('.deal__header--interactive');
        titlesList.forEach(title => {
          const height = title.offsetHeight;
          if (titleHeight < height) titleHeight = height;
        });
        const websitelinkList = carouselWrapperRef.current.querySelectorAll('.deal__details-top-contacts');
        const hasChildren = Array.from(websitelinkList).some(element => {
          return element.children.length > 0;
        });
        if (hasChildren) websiteHeight = 42;
        setTitleHeight(titleHeight);
        setWebsiteHeight(websiteHeight);
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, facets, defaultFacets]);
  useEffect(() => {
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:${value}`;
    });
    const facetNames = getFacetNamesValue(filterData);
    const defaultFacets = {
      facets: [...facetNames],
      facetFilters: [[...types]],
      hitsPerPage: pageSize
    };
    const itemFilters = {
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFilters],
      hitsPerPage: pageSize
    };
    let defaultResponsefacets;
    getListing(algoliaIndexes, defaultFacets, algoliaSettings).then(response => {
      defaultResponsefacets = response.facets;
    }).then(() => getListing(algoliaIndexes, itemFilters, algoliaSettings)).then(response => {
      setFacets(response.facets);
      setHits(response.hits);
      setDefaultFacets(defaultResponsefacets);
    }).catch(error => {
      console.log('error', error);
    });
  }, [location.search]);
  const renderItems = useMemo(() => {
    if (!hits.length) {
      return [];
    }
    return hits.map(deal => /*#__PURE__*/React.createElement(OfferAndDeal, {
      key: deal.objectID,
      userProfile: userProfile,
      fromText: fromText,
      offText: offText,
      expiresSoonText: expiresSoonText,
      bookNowText: bookNowText,
      termsAndConditionsText: termsAndConditionsText,
      deal: deal,
      rtl: rtl,
      currency: currency,
      gridMode: false,
      socialSharing: socialSharing,
      eventsAnalytics: eventsAnalytics,
      params: params,
      ratingTextStars: ratingTextStars,
      isSwipeable: false,
      isDraggable: false
    }));
  }, [facets, defaultFacets]);
  if (isNil(fields) || isNil(fields.data)) {
    console.info('UnbelievableSummerDeals component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [UnbelievableSummerDeals component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--websiteLinks-height': websiteHeight
    }
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      moveToSlide
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "switchWithBtnGroup"
    }, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("p", {
      className: "title"
    }, title), description && /*#__PURE__*/React.createElement("p", {
      className: "description"
    }, description), filtersArray && filtersArray.map((filter, index) => {
      const fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
      const fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
      let itemfacets;
      let defaultItemFacets;
      if (facets && defaultFacets) {
        itemfacets = facets[fieldNameItem] || facets[fieldNameItem + 'RangeIndex'];
        defaultItemFacets = defaultFacets[fieldNameItem] || defaultFacets[fieldNameItem + 'RangeIndex'];
      }
      if (fieldTypeItem === 'Toggle Single Select') {
        return /*#__PURE__*/React.createElement(Switch, {
          fields: filter,
          facets: itemfacets,
          defaultFacets: defaultItemFacets,
          facetsName: fieldNameItem,
          firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
          setFilter: () => {
            moveToSlide(0);
          },
          clearAlllFilters: false,
          isTagPage: false,
          dictionary: dictionary,
          firstFilter: true,
          analytics: analytics,
          getFilterValue: () => null,
          rtl: rtl,
          resetAllFiltersCallback: () => null,
          autoWidth: true,
          summerDeals24: true,
          key: index,
          selectAllLabel: selectAllLabel,
          skipFacetsFilter: true
        });
      } else {
        return /*#__PURE__*/React.createElement("div", {
          key: index
        });
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToPrevAnalytics'], params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToNextAnalytics'], params))))), renderCarousel(renderItems, {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4,
          slidesToSlide: 1
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 3,
          slidesToSlide: 1
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2,
          slidesToSlide: 1
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1,
          slidesToSlide: 1
        }
      },
      containerClass: 'carouselContainer'
    }), !hits.length ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: '36px',
        fontWeight: '600',
        marginBottom: '50px'
      }
    }, "no deals available") : null, /*#__PURE__*/React.createElement("div", {
      className: "ctaButton-wrapper"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "ctaButton-wrapper__fadeInUp",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      delay: 200
    }, showMoreButtonText && showMoreButtonHref ? /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      className: "btn btn-secondary btn-mob",
      href: showMoreButtonHref,
      title: `${showMoreButtonText.value}`,
      onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToMoreDealsAnalytics'], params), [title, showMoreButtonText])
    }, showMoreButtonText) : null), /*#__PURE__*/React.createElement("div", {
      className: "paginationDot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToBubblesAnalytics'], params))))));
  })));
};
const UnbelievableSummerDeals = props => checkJssError(props, UnbelievableSummerDealsComponent);
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1r5r7fs";
const rtlStyles = "r1849wm9";
const ltrStyles = "l1ptt8n8";
export default UnbelievableSummerDeals;